import React from 'react';
import DefaultLayout from 'components/layout/DefaultLayout';
import { ISupportLanguage } from 'utils/types/storyTypes';
import Wrapper from './Wrapper';
/**
 * * 리소스 - 미니컷 수정 페이지
 */

interface IProps {
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
  supportLangList: ISupportLanguage[] | null;
  type: string;
}

const UpdatePage: React.FC<IProps> = ({
  data,
  setData,
  supportLangList,
  type,
}) => {
  return (
    <DefaultLayout>
      <Wrapper
        data={data}
        setData={setData}
        supportLangList={supportLangList}
        type={type}
      />
    </DefaultLayout>
  );
};

export default UpdatePage;
